import { Box, TextField, TextFieldProps } from '@mui/material';
import { IconButton, colors } from '@sweep-io/sweep-design';
import { Search as MagnifyingGlassIcon } from '@sweep-io/sweep-design/dist/icons';
import { Close as CloseIcon } from '@sweep-io/sweep-design/dist/icons';
import React from 'react';

export interface SearchInputProps extends Pick<TextFieldProps, 'onChange' | 'value'> {
  withFixedMagnifyingGlassIcon?: boolean;
  TextFieldProps?: TextFieldProps;
  dataTestId?: string;
  placeholder?: string;
  onClearButtonClick?: () => void;
  endAdornment?: React.ReactNode;
  forceCloseButton?: boolean;
  autoFocus?: boolean;
  variant?: 'default' | 'small';
}

export const SearchInput = ({
  onClearButtonClick,
  withFixedMagnifyingGlassIcon,
  TextFieldProps = {},
  dataTestId,
  placeholder,
  endAdornment,
  forceCloseButton,
  autoFocus,
  onChange,
  value,
  variant = 'default',
}: SearchInputProps) => {
  const InputSx =
    variant === 'small'
      ? {
          minHeight: '32px',
          input: {
            paddingTop: '5px',
            paddingBottom: '5px',
          },
        }
      : {};

  const { InputProps: TextFieldInputProps, ..._TextFieldProps } = TextFieldProps;

  return (
    <Box sx={{ width: '100%' }}>
      <TextField
        data-testid={dataTestId}
        size="small"
        fullWidth
        autoFocus={autoFocus}
        placeholder={placeholder || 'Search'}
        InputProps={{
          sx: {
            paddingLeft: withFixedMagnifyingGlassIcon ? '25px' : 0,
            '&::placeholder': {
              color: colors.grey[700],
            },
            ...InputSx,
          },
          startAdornment: withFixedMagnifyingGlassIcon ? (
            <Box
              sx={{
                color: colors.grey[800],
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <MagnifyingGlassIcon />
            </Box>
          ) : null,
          endAdornment: (
            <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: 1 }}>
              {endAdornment && endAdornment}
              {(forceCloseButton || (!!TextFieldProps.value && TextFieldProps.value !== '')) &&
                onClearButtonClick && (
                  <IconButton variant="flat" size="tiny" onClick={onClearButtonClick}>
                    <CloseIcon />
                  </IconButton>
                )}
            </Box>
          ),
          ...TextFieldInputProps,
        }}
        {...{ onChange, value, ..._TextFieldProps }}
      />
    </Box>
  );
};
